export default __webpack_public_path__ + "static/media/e_StatRep.513ae447.pdf";